"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalHistory = createMedicalHistory;
const shared_1 = require("../../shared");
const createCardiovascularDiseases_1 = require("./createCardiovascularDiseases");
const createChronicLiverFailure_1 = require("./createChronicLiverFailure");
const createHaemostaseology_1 = require("./createHaemostaseology");
const createHepatologyDiseases_1 = require("./createHepatologyDiseases");
const createMedicalTreatment_1 = require("./createMedicalTreatment");
const createMetabolicDiseases_1 = require("./createMetabolicDiseases");
const createNephrectomyOrGraftectomy_1 = require("./createNephrectomyOrGraftectomy");
const createOncologyDiseases_1 = require("./createOncologyDiseases");
const createOterDisorders_1 = require("./createOterDisorders");
const createOtherSurgicalInterventions_1 = require("./createOtherSurgicalInterventions");
const createRenalAnaemiaHematology_1 = require("./createRenalAnaemiaHematology");
const createRisks_1 = require("./createRisks");
const messages = {
    medicalHistory: {
        id: "ktx.dashboard.medical_history",
        defaultMessage: "Anamnézis"
    }
};
function createMedicalHistory(intl, options) {
    const metabolicDiseases = (0, createMetabolicDiseases_1.createMetabolicDiseases)(intl, options);
    const otherDisorders = (0, createOterDisorders_1.createOtherDisorders)(intl, options);
    const otherSurgicalIntervention = (0, createOtherSurgicalInterventions_1.createOtherSurgicalIntervention)(intl, options);
    const medicalTreatment = (0, createMedicalTreatment_1.createMedicalTreatment)(intl, options);
    const cardiovascularDiseases = (0, createCardiovascularDiseases_1.createCardiovascularDiseases)(intl, options);
    const nephrectomyOrGraftectomy = (0, createNephrectomyOrGraftectomy_1.createNephrectomyOrGraftectomy)(intl, options);
    const oncologyDiseases = (0, createOncologyDiseases_1.createOncologyDiseases)(intl, options);
    const renalAnaemiaHematology = (0, createRenalAnaemiaHematology_1.createRenalAnaemiaHematology)(intl, options);
    const haemostaseology = (0, createHaemostaseology_1.createHaemostaseology)(intl, options);
    const chronicLiverFailure = (0, createChronicLiverFailure_1.createChronicLiverFailure)(intl, options);
    const hepatologyDiseases = (0, createHepatologyDiseases_1.createHepatologyDiseases)(intl, options);
    const risks = (0, createRisks_1.createRisks)(intl, options);
    const content = (0, shared_1.createSectionContent)([
        metabolicDiseases,
        otherDisorders,
        otherSurgicalIntervention,
        medicalTreatment,
        hepatologyDiseases,
        cardiovascularDiseases,
        nephrectomyOrGraftectomy,
        oncologyDiseases,
        renalAnaemiaHematology,
        haemostaseology,
        chronicLiverFailure,
        risks
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.medicalHistory, content });
}
